import {HttpClient, HttpContext} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {ApiResponse} from '../../../auth/auth.models';
import {buildApiUrl} from '../../api/api-url';
import {LOCALLY_HANDLED_API_ERROR_CODES} from '../../errors/local-api-error';
import {PhotoGalleryKind} from './photo-gallery-kind';
import {PhotoGalleryResponseDto} from './photo-gallery-response-dto';

@Injectable({providedIn: 'root'})
export class PhotoGalleryService {
  private readonly http = inject(HttpClient);

  load(kind: PhotoGalleryKind, id: string): Observable<string[]> {
    const context = new HttpContext().set(LOCALLY_HANDLED_API_ERROR_CODES, ['RecordNotFound']);
    return this.http.get<ApiResponse<PhotoGalleryResponseDto>>(
      buildApiUrl(`/v1/photo-galleries/${kind}/${encodeURIComponent(id)}`), {context},
    ).pipe(map(response => [...new Set((response.data?.originalUrls ?? []).filter(url => !!url.trim()))]));
  }
}
